import type { CourseCardItem } from '../types/course-card';

const trimSlashes = (value: string): string => value.replace(/^\/+|\/+$/gu, '');

export const resolveCourseCardHref = (
  course: Pick<CourseCardItem, 'href' | 'primaryCategory' | 'slug'>,
): string => {
  const href = course.href?.trim();
  if (href) return href;

  const slug = trimSlashes(course.slug);
  const primaryCategory = course.primaryCategory?.trim();

  if (primaryCategory) {
    return `/${trimSlashes(primaryCategory)}/${slug}`;
  }

  return `/cursos/${slug}`;
};
